import styled from "@emotion/styled";
import { Box, Card } from "@mui/material";

export const QRCodeContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    flex-direction: column;
`

export const ConexaoContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    padding: 2rem 1rem;
`

export const CodigoContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    flex-direction: column;
`

export const AlterarNumeroContainer = styled(Card)`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    margin-bottom: 1.5rem;
    padding: 0.75rem 1rem;
`

export const ButtonsContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
`
